/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Waypoint } from "../../waypoints";

export const protobufPackage = "skills";

export interface DockGpsEstimatorActionArgs {
  timeoutS: number;
}

export interface DockGpsEstimatorResultData {
  dockGpsWaypoint: Waypoint | undefined;
}

export interface DockGpsEstimatorActionStateData {
}

function createBaseDockGpsEstimatorActionArgs(): DockGpsEstimatorActionArgs {
  return { timeoutS: 0 };
}

export const DockGpsEstimatorActionArgs = {
  encode(message: DockGpsEstimatorActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.timeoutS !== 0) {
      writer.uint32(13).float(message.timeoutS);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DockGpsEstimatorActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockGpsEstimatorActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 13) {
            break;
          }

          message.timeoutS = reader.float();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockGpsEstimatorActionArgs {
    return { timeoutS: isSet(object.timeoutS) ? globalThis.Number(object.timeoutS) : 0 };
  },

  toJSON(message: DockGpsEstimatorActionArgs): unknown {
    const obj: any = {};
    if (message.timeoutS !== 0) {
      obj.timeoutS = message.timeoutS;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockGpsEstimatorActionArgs>, I>>(base?: I): DockGpsEstimatorActionArgs {
    return DockGpsEstimatorActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockGpsEstimatorActionArgs>, I>>(object: I): DockGpsEstimatorActionArgs {
    const message = createBaseDockGpsEstimatorActionArgs();
    message.timeoutS = object.timeoutS ?? 0;
    return message;
  },
};

function createBaseDockGpsEstimatorResultData(): DockGpsEstimatorResultData {
  return { dockGpsWaypoint: undefined };
}

export const DockGpsEstimatorResultData = {
  encode(message: DockGpsEstimatorResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.dockGpsWaypoint !== undefined) {
      Waypoint.encode(message.dockGpsWaypoint, writer.uint32(18).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DockGpsEstimatorResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockGpsEstimatorResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 2:
          if (tag !== 18) {
            break;
          }

          message.dockGpsWaypoint = Waypoint.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DockGpsEstimatorResultData {
    return { dockGpsWaypoint: isSet(object.dockGpsWaypoint) ? Waypoint.fromJSON(object.dockGpsWaypoint) : undefined };
  },

  toJSON(message: DockGpsEstimatorResultData): unknown {
    const obj: any = {};
    if (message.dockGpsWaypoint !== undefined) {
      obj.dockGpsWaypoint = Waypoint.toJSON(message.dockGpsWaypoint);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DockGpsEstimatorResultData>, I>>(base?: I): DockGpsEstimatorResultData {
    return DockGpsEstimatorResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockGpsEstimatorResultData>, I>>(object: I): DockGpsEstimatorResultData {
    const message = createBaseDockGpsEstimatorResultData();
    message.dockGpsWaypoint = (object.dockGpsWaypoint !== undefined && object.dockGpsWaypoint !== null)
      ? Waypoint.fromPartial(object.dockGpsWaypoint)
      : undefined;
    return message;
  },
};

function createBaseDockGpsEstimatorActionStateData(): DockGpsEstimatorActionStateData {
  return {};
}

export const DockGpsEstimatorActionStateData = {
  encode(_: DockGpsEstimatorActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DockGpsEstimatorActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDockGpsEstimatorActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): DockGpsEstimatorActionStateData {
    return {};
  },

  toJSON(_: DockGpsEstimatorActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<DockGpsEstimatorActionStateData>, I>>(base?: I): DockGpsEstimatorActionStateData {
    return DockGpsEstimatorActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DockGpsEstimatorActionStateData>, I>>(_: I): DockGpsEstimatorActionStateData {
    const message = createBaseDockGpsEstimatorActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
